export default "__VITE_ASSET__$SU9BA0u__"